import { gql } from '@apollo/client'

export default gql`
  mutation deleteAdUnitSize($id: ID!) {
    deleteSize(id: $id) {
      data {
        id
      }
    }
  }
`
